import { Button } from 'antd';
import type { ActionButtonType } from './ActionButtonType';
import "./actionButton.css";

const ActionButton: React.FC<ActionButtonType> = ({ text, icon, className, onClick, iconPosition, disabled, styles = {}, loading, onMouseDown, children }) => (
    <Button
        type="primary"
        style={styles}
        icon={icon}
        className={`action-button ${className}`}
        iconPosition={iconPosition}
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        onMouseDown={onMouseDown}
    >
        {text || children}
    </Button>
)

export default ActionButton;
